
export default function infoColumn() {

    return [{
        name: 'device', label: 'Device',
        options: { display: 'excluded'}
    }, {
        name: 'pageProductCategory', label: 'Product Category',
        options: { display: 'excluded'}
    }, {
        name: 'pageCategory', label: 'Mono/Multi Brand',
        options: { display: 'excluded'}
    }, {
        name: 'sectionName', label: 'Section',
        options: { display: 'excluded'}
    }, {
        name: 'resourceType', label: 'Resource Type',
        options: { display: 'excluded'}
    }, {
        name: 'tag', label: 'Tag',
        options: {
            display: 'excluded',
            customBodyRowRender: value => value.length ? value : 'Empty'
        }
    }]
}